import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface IssueVerificationItemsServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<IssueVerificationItemsServiceData>(
    db,
    'issueVerificationItemsService'
  );

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
